export const sortManualValuesNewestFirst = <T extends { date: string }>(
	manualValues: T[],
) => [...manualValues].sort((a, b) => b.date.localeCompare(a.date));
